import { render, staticRenderFns } from "./ModeSwitcher.vue?vue&type=template&id=c226e3fa&scoped=true"
import script from "./ModeSwitcher.vue?vue&type=script&lang=js"
export * from "./ModeSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ModeSwitcher.vue?vue&type=style&index=0&id=c226e3fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c226e3fa",
  null
  
)

export default component.exports